const governmentMutations = {
    updateGuid(state, Guid) {
        state.Guid = Guid;
    },
    updateArticleListType(state, articleListType) {
        state.articleListType = articleListType;
    },
    updateAttrForSelect(state, attrForSelect) {
        state.attrForSelect = attrForSelect;
    },
    updateEmileAddress(state, emileAddress) {
        state.emileAddress = emileAddress;
    },
    updateWebchanneltypeid(state, webchanneltypeid) {
        state.webchanneltypeid = webchanneltypeid;
    },
    updateIsdefault(state, isdefault) {
        state.isdefault = isdefault;
    },
    updateSendTagsList(state, sendTagsList) {
        state.sendTagsList = sendTagsList;
    },
    updateHotWords(state, hotWords) {
        state.hotWords = hotWords
    },
    updateBreadcrumbDataFirst(state, breadcrumbDataFirst) {
        // state.breadcrumbData.push(breadcrumbData);
        state.breadcrumbDataFirst = breadcrumbDataFirst
    },
    updateBreadcrumbData(state, breadcrumbData) {
        // state.breadcrumbData.push(breadcrumbData);
        state.breadcrumbData = breadcrumbData
    },
    
}

export default governmentMutations